import React from 'react';
import { cn } from '../../../utils/cn';

// Tone is expressed ONLY as a 3px full-height left accent bar (no tinted bg,
// no icon, no hover). Text colors do not change with tone.
const ACCENT_BY_TONE = {
  primary: 'bg-dash-chart-1',
  neutral: 'bg-dash-chart-1',
  warning: 'bg-dash-warning',
  destructive: 'bg-dash-destructive',
  danger: 'bg-dash-destructive',
  success: 'bg-dash-success',
};

const MetricsCard = ({ title, value, change, subtitle, color = 'primary' }) => {
  const accent = ACCENT_BY_TONE[color] || ACCENT_BY_TONE.primary;

  return (
    <div className="relative overflow-hidden rounded-md border border-dash-border bg-dash-card px-3.5 py-3">
      <span className={cn('absolute inset-y-0 left-0 w-[3px]', accent)} />
      <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-dash-muted-foreground truncate">
        {title}
      </p>
      <div className="mt-1 flex items-baseline gap-2">
        <span className="text-2xl font-semibold tabular-nums leading-none text-dash-foreground">
          {value}
        </span>
        {change ? (
          <span className="text-[11px] text-dash-muted-foreground">{change}</span>
        ) : null}
      </div>
      {subtitle ? (
        <p className="mt-1 text-[11px] text-dash-muted-foreground truncate">{subtitle}</p>
      ) : null}
    </div>
  );
};

export default MetricsCard;
